var React = require('react');

function ProductsIcon40Inline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Obszar_roboczy_56","data-name":"Obszar roboczy 56","transform":"translate(-5.62 -12.06)"},[React.createElement("path",{"id":"Path_390","data-name":"Path 390","d":"M34.38,26.44h-3a11.268,11.268,0,0,0-3.33-8.04l2.12-2.12a14.263,14.263,0,0,1,4.21,10.17Z","key":0}),React.createElement("path",{"id":"Path_391","data-name":"Path 391","d":"M8.62,26.44h-3A14.4,14.4,0,0,1,20,12.06c.36,0,.71.01,1.06.04l-.21,2.99c-.28-.02-.56-.03-.85-.03A11.393,11.393,0,0,0,8.62,26.44Z","key":1}),React.createElement("path",{"id":"Path_392","data-name":"Path 392","d":"M24.65,13.16,18.11,26.44H21.2l6.55-13.28Z","key":2})]));
}

ProductsIcon40Inline.defaultProps = {"width":"28.76","height":"14.39","viewBox":"0 0 28.76 14.39"};

module.exports = ProductsIcon40Inline;

ProductsIcon40Inline.default = ProductsIcon40Inline;
